import {groupBy3Constants} from "../constants/groupBy3Constants";

const initialState = {
    data: {
        records: [],
        page: 0,
        recordsPerPage: 0,
        totalRecords: 0,
        total: {}
    },
    errorMsg: "",
    isLoading: false,
    name: "",
    orderBy: "",
    sortBy: "",
    sortColumns: [],
    rerender: false,
    selectedUUIDs: new Set(),
    selectedRows: new Set(),
    groupBy: {
        "label": "City",
        "groupBy": "city",
        "sortBy": "city"
    }
};

const groupBy3Reducer = (state = initialState, action) => {
    switch (action.type) {
        case groupBy3Constants.GROUP_BY_3_LOADING_SPINNER:
            return {
                ...state,
                isLoading: true,
            };
        case groupBy3Constants.GROUP_BY_3_STOP_LOADING_SPINNER:
            return {
                ...state,
                isLoading: false,
            };
        case groupBy3Constants.GROUP_BY_3_INFINITY_SCROLL:
            return {
                ...state,
                data: {
                    records: [...state.data.records, ...action?.result?.records],
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    totalRecords: action?.result?.totalRecords,
                    total: action?.result?.total
                },
                errorMsg: '',
                isLoading: false
            };
        case groupBy3Constants.GROUP_BY_3_GET_DATA:
            return {
                ...state,
                data: {
                    records: action?.result?.records,
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    totalRecords: action?.result?.totalRecords,
                    total: action?.result?.total
                },
                errorMsg: '',
                isLoading: false,
                rerender: false
            };
        case groupBy3Constants.GROUP_BY_3_ERROR:
            return {
                ...state,
                errorMsg: 'Unable to load data. Please try again.',
                rerender: false,
                isLoading: false,
            };
        case groupBy3Constants.GROUP_BY_3_UPDATE_ORDER_BY:
            return {
                ...state,
                orderBy: action.orderBy
            };
        case groupBy3Constants.GROUP_BY_3_UPDATE_SORT_BY:
            return {
                ...state,
                sortBy: action.sortBy
            };
        case groupBy3Constants.GROUP_BY_3_UPDATE_SORT_COLUMNS:
            return {
                ...state,
                sortColumns: action.sortColumns
            };
        case groupBy3Constants.GROUP_BY_3_RERENDER:
            return {
                ...state,
                rerender: true
            };
        case groupBy3Constants.GROUP_BY_3_SET_SELECTED_ROW:
            return {
                ...state,
                selectedUUIDs: action?.payload?.selectedUUIDs,
                selectedRows: action?.payload?.selectedRows
            };
        case groupBy3Constants.GROUP_BY_3_UPDATE_GROUP_BY:
            return {
                ...state,
                groupBy: action.groupBy
            };
        case groupBy3Constants.GROUP_BY_3_RESET:
            return initialState;
        default:
            return state;
    }
};

export default groupBy3Reducer;